export default {
  install(Vue, { router }) {
    router.addRoutes([
      {
        path: '/test',
        component: () => import('./Test.vue'),
        props: true,
      },
    ]);
  },
};
